import { makeStyles, Theme } from '@material-ui/core'
import { BaseColors } from '../../../configs/types'

const buildStyles = makeStyles((theme: Theme) => ({
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
  container: {
    opacity: 0,
    animation: '$fadeIn 0.5s',
    'animation-fill-mode': 'forwards',
  },
  itemContainer: {
    alignSelf: 'normal',
    padding: '10px',
    paddingBottom: '40px',
    display: 'flex',
    justifyContent: 'center',
  },

  item: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '10px',
    minHeight: '230px',
    background: '#ffffff',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.9)',
    borderRadius: '20px',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0px 6px 25px rgba(0, 0, 0, 0.95)',
    },
  },

  name: {
    margin: '15px 20px 7px 20px',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '22px',
    textAlign: 'center',
  },

  description: {
    margin: '7px 20px',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '18px',
    textAlign: 'center',
  },

  moreButton: (props: { baseColors: BaseColors }) => {
    return {
      padding: '10px',
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '13px',
      lineHeight: '17px',
      letterSpacing: '0.03em',
      textTransform: 'uppercase',
      color: props.baseColors.primary,
      cursor: 'pointer',
    }
  },
}))

export default buildStyles
